<template>
  <Modal
    v-model="_value"
    width="500"
    title="修改客户配件质保期"
    @on-visible-change="visibleChange"
    @on-ok="onOk"
    ok-text="修改">
    <Form ref="loginForm" :model="positioningDeviceFitting" style="display: inline;">
      <FormItem prop="clientGuaranteePeriod" label="客户配件质保期">
        <DatePicker style="display: inline-block; width: 200px;" type="date"
                    v-model="positioningDeviceFitting.clientGuaranteePeriod"
                    placeholder="选择日期"></DatePicker>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'modifypositioningdevicefittingclientguaranteeperiodmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      positioningDeviceFitting: {
        id: null,
        clientGuaranteePeriod: null
      }
    }
  },
  methods: {
    ...mapActions([
      'PositioningDeviceFittingServ_GetDetail',
      'PositioningDeviceFittingServ_ModifyClientGuaranteePeriod'
    ]),
    onOk () {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确认修改服务到费期</p>',
        onOk: () => {
          if (this.positioningDeviceFitting.clientGuaranteePeriod) {
            this.positioningDeviceFitting.clientGuaranteePeriod = new Date(this.positioningDeviceFitting.clientGuaranteePeriod).getTime()
          }
          store.dispatch('PositioningDeviceFittingServ_ModifyClientGuaranteePeriod', {
            params: this.positioningDeviceFitting
          }).then(() => {
            this.$Message.success('修改成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {

        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.positioningDeviceFitting.id = null
        this.positioningDeviceFitting.clientGuaranteePeriod = null
        store.dispatch('PositioningDeviceFittingServ_GetDetail', {
          params: { id: this._initValue }
        }).then(() => {
          this.positioningDeviceFitting = store.getters.get_PositioningDeviceFitting_GetDetailResult
          if (this.positioningDeviceFitting.clientGuaranteePeriod) {
            this.positioningDeviceFitting.clientGuaranteePeriod = new Date(this.positioningDeviceFitting.clientGuaranteePeriod)
          }
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
